import script from "./IDETextEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDETextEditor.vue?vue&type=script&lang=ts&setup=true"

import "./IDETextEditor.vue?vue&type=style&index=0&id=6e29df0d&lang=less"

const __exports__ = script;

export default __exports__